import { useCallback } from 'react'

import { AssignmentStatuses } from '@lyrahealth-inc/shared-app-logic/src/features/assignments/types'
import { getProviderDraftResponse } from '@lyrahealth-inc/shared-app-logic/src/features/assignments/utils'
import { Assignment } from '@lyrahealth-inc/shared-app-logic/src/models/assignments/Assignments'

import { useUpdateAssignmentMutation, useUpdateAssignmentResponseMutation } from '../assignmentsApi'

/**
 * Completes Action Plan assignments when an episode ends. For each Action Plan it first
 * submits the provider-started response as completed then marks the assignment completed.
 */
export const useCompleteActionPlans = () => {
  const [updateAssignment] = useUpdateAssignmentMutation()
  const [updateAssignmentResponse] = useUpdateAssignmentResponseMutation()

  return useCallback(
    (actionPlans: Assignment[]) =>
      Promise.all(
        actionPlans.map(async (actionPlan) => {
          const providerStartedResponse = getProviderDraftResponse(actionPlan)
          if (providerStartedResponse && providerStartedResponse.status !== AssignmentStatuses.completed) {
            await updateAssignmentResponse({
              ...providerStartedResponse,
              status: AssignmentStatuses.completed,
            }).unwrap()
          }
          await updateAssignment({ ...actionPlan, status: AssignmentStatuses.completed }).unwrap()
        }),
      ),
    [updateAssignment, updateAssignmentResponse],
  )
}
